import { useRef } from "react";
import { CardContent, Grid, Button } from "@mui/material";
import { IActiveModal } from "src/pages/Admin/AdminWindow";
import { UserDeviceDataGrid } from "./UserDeviceDataGrid";
import { UserDeviceInviteModal } from "./BulkInvite";
interface IManageUserDevicesProps {
  id: string;
  setActiveModal: (activeModal: IActiveModal) => void;
}

export const ManageUserDevices = (props: IManageUserDevicesProps): JSX.Element => {
  const { id, setActiveModal } = props;

  /** Get height of the right panel and apply to max menu size */
  const contentRef = useRef<HTMLDivElement>();
  return (
    <CardContent>
      <Grid container ref={contentRef} spacing={2}>
        <Grid item xs={12}>
          <UserDeviceInviteModal />
        </Grid>
        <Grid item xs={12}>
          <UserDeviceDataGrid setActiveModal={setActiveModal} />
        </Grid>
      </Grid>
    </CardContent>
  );
};
